import { gql } from '@apollo/client';
import { REPORTING_REPORTER_ITEM } from '../fragments/reportingRequirement';

export const REPORTING_REQUIREMENT_DEFAULTS = gql`
  query reportingRequirementDefaults($input: ReportingRequirementDefaultsInput!) {
    defaults: reportingRequirementDefaults(input: $input) {
      associationType
      associationId
      associationName
      startDate
      endDate
      reporters {
        ...reportingReporterItem
      }
    }
  }
  ${REPORTING_REPORTER_ITEM}
`;
